<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="600px"
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense class="px-4 pt-3" flat>
          <h3></h3>
          <v-spacer>Copy Module</v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-5 py-3">
          <v-container style="height: max-content" v-if="inventory">
            <div class="mb-5 w-full" v-if="courses.length">
              <v-select
                dense
                label="Course"
                :items="courses"
                item-text="title"
                item-value="id"
                return-object
                @change="onSelectCourse"
                placeholder="Choose Course"
                v-model="course"
                :disabled="inventory && inventory.type == 'other'"
              ></v-select>
            </div>
            <div class="mb-1 w-full">
              <v-select
                dense
                label="Section"
                :disabled="!sections.length"
                :items="sections"
                item-text="title"
                item-value="id"
                return-object
                placeholder="Choose Section"
                v-model="section"
              ></v-select>
            </div>
            <v-overlay
              :absolute="true"
              color="white"
              opacity="1"
              :value="copying"
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                color="#006341"
              ></v-progress-circular>
              <b class="color_default">Loading...</b>
            </v-overlay>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed dark color="var(--g)" @click="onCopy">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: "ViewDetailMateri",
  props: ["dialog", "inventory"],
  watch: {
    dialog(_newValue, _oldValue) {
      this.course = null;
      this.section = null;
      this.sections = [];
      if (this.inventory?.type == "other") {
        this.course = this.courses.find(
          (el) => el.id == this.$route.params.idCourse,
        );
        if (this.course) {
          this.fetchSection();
        }
      }
    },
  },
  components: { StarRating },
  data() {
    return {
      sections: [],
      courses: [],
      course: null,
      section: null,
      loading: false,
      copying: false,
    };
  },
  mounted() {
    this.fetchCourse();
  },
  methods: {
    fetchCourse() {
      this.loading = true;
      let data = {
        path: `manage/course`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          const raw = data.data;

          this.courses = raw;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section/${this.course?.id}?include=modules`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          const raw = data.data;
          this.sections = raw;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    onSelectCourse() {
      console.log(this.course);
      this.fetchSection();
    },
    onCopy(item) {
      this.copying = true;
      let body = {
        module_id: this.inventory.module_id,
        instance_id: this.inventory.instance_id,
        course_section_id: this.$route.params.idSection,
        new_course_section_id: this.section?.id,
      };
      let data = {
        path: `copy/module`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((res) => {
          this.copying = false;
          res["data_module"] = this.inventory.data_module;
          console.log(res);

          this.$emit("refetch", res);
          this.$emit("close");
        })
        .catch((err) => {
          console.log(err);

          item.copying = false;
        });
    },
  },
};
</script>

<style></style>
